import React from 'react';
import clinicData from '../data/clinicData.json';

const AppointmentOffline = () => {
  return (
    <div className="bg-gradient-to-br from-cream to-sage overflow-auto">
      <div className="bg-white shadow-md">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <h1 className="text-2xl sm:text-3xl font-bold gradient-text text-center">Clinic Visit</h1>
          <p className="text-gray-600 text-center mt-2">Book your clinic appointment with Dr. Vrushali Ghate</p>
        </div>
      </div>

      <div className="py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl p-6">
            <iframe 
              src={clinicData.contact.appointmentUrlOffline}
              width="100%" 
              height="800" 
              frameBorder="0" 
              scrolling="yes"
              className="rounded-lg min-h-screen"
              style={{minHeight: '100vh'}}
              title="Clinic Visit Appointment Booking Calendar"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentOffline;